import { action, thunk, persist } from 'easy-peasy';
import { httpGetMyAccount } from "services/accounts"

const model = {
  loading: false,
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  account: {},
  setAccount: action((state, payload) => {
    state.account = payload
  }),
  accounts: [],
  setAccounts: action((state, payload) => {
    state.accounts = payload
  }),
  getAccount: thunk(async (actions, payload) => {
    try {
      actions.setLoading(true);
      // Placeholder implementation since my_accounts endpoint is no longer available
      console.log("getAccount called - my_accounts endpoint removed");
      
      // Set default account data or leave empty
      actions.setAccount({});
      actions.setAccounts([]);
    } catch (error) {
      console.error("Error fetching accounts:", error);
    } finally {
      actions.setLoading(false);
    }
  }),
};

export default model;